/**
 * Display constants for the Document Review column, kept apart from the cell
 * component so react-refresh sees a component-only file.
 */
import { StatusChipColor } from "components/StatusChip";

export const DOCUMENT_STATES = [
  "needsReview",
  "failed",
  "notProcessed",
  "processing",
  "approved",
  "none",
] as const;
export type DocumentState = (typeof DOCUMENT_STATES)[number];

export const DOCUMENT_STATE_LABELS: Record<DocumentState, string> = {
  needsReview: "Needs review",
  failed: "Failed",
  notProcessed: "Not processed",
  processing: "Processing",
  approved: "Approved",
  none: "No Document",
};

/** StatusChip color per document state, matching the Manifest Review datagrid's chip palette. */
export const DOCUMENT_STATE_CHIP_COLOR: Record<DocumentState, StatusChipColor> = {
  needsReview: "warning",
  failed: "error",
  notProcessed: "default",
  processing: "info",
  approved: "success",
  none: "default",
};

/**
 * Hover copy answering what the
 * status means and, for the actionable states (failed / notProcessed / none),
 * what clicking the chip does about it.
 */
export const DOCUMENT_STATE_TOOLTIP: Record<DocumentState, string> = {
  needsReview: "Document data was extracted and is awaiting Encamp review.",
  notProcessed:
    "A document is attached but its data hasn't been processed. Click to open this manifest's documents and process it.",
  processing: "Document data is being extracted. Check back shortly.",
  approved: "Document data has been reviewed and approved.",
  failed:
    "Data extraction failed. Click to open this manifest's documents and re-process or upload a better copy.",
  none: "No source document is attached to this manifest. Click to open documents and upload one.",
};

/**
 * Tooltip variant for non-interactive renders (no onClick wired): same state
 * descriptions minus the "Click to…" call-to-action sentences.
 */
export const DOCUMENT_STATE_TOOLTIP_STATIC: Record<DocumentState, string> = {
  needsReview: "Document data was extracted and is awaiting Encamp review.",
  notProcessed: "A document is attached but its data hasn't been processed.",
  processing: "Document data is being extracted. Check back shortly.",
  approved: "Document data has been reviewed and approved.",
  failed: "Data extraction failed.",
  none: "No source document is attached to this manifest.",
};
